import { dataModeOnExistingCollectionsIndicator } from '@wix/bi-logger-platform/v2'
import { enableDataMode, isDataModeEnabled } from '@wix/wix-data-client-common'
import { preferences } from '@wix/wix-data-client-common/dist/esm/createOrEditCollectionPanel'

export default async ({
  appApi,
  logger,
  editorSdkProxy,
  dataSettingsManager,
  safeUserPreferences,
  collectionsApi,
}) => {
  editorSdkProxy.addEventListener('focusedPageChanged', event => {
    logger.breadcrumb({
      category: 'event',
      message: `focused page changed to ${event.detail.pageRef.id}`,
    })
  })
  return async function ({ eventType, eventPayload }) {
    switch (eventType) {
      case 'siteWasFirstSaved':
        appApi.emit('siteWasFirstSaved')
        break
      case 'siteWasPublished':
        appApi.emit('siteWasPublished')
        break
      case 'enableDataModeClicked': {
        const { origin } = eventPayload
        const originsToSilentlyEnableDataMode = [
          'responsivePagesPanel/turnOnData',
          '6th_button_data_panel',
          'AddContentManagerPanel',
          'convert_to_dynamic_from_page_actions',
          'suggest_dynamic_pages_on_duplicate',
        ]

        const originsToSkipDataPanelOpening = [
          'convert_to_dynamic_from_page_actions',
          'suggest_dynamic_pages_on_duplicate',
        ]

        const shouldOpenPresetsPanel =
          !originsToSilentlyEnableDataMode.includes(origin)

        const openDataPanelOnStart =
          !originsToSkipDataPanelOpening.includes(origin)

        try {
          await editorSdkProxy.editor.updateAppState({
            openDataPanelOnStart,
          })
          await enableDataMode({ dataSettingsManager, logger })

          safeUserPreferences.set({
            [preferences.INTRO_WAS_SHOWN]: true,
          })

          if (shouldOpenPresetsPanel) {
            appApi.openAddDynamicPagePanelV4({
              origin: eventPayload.origin,
              isFirstTimeExperience: true,
            })
          }
          logger.bi(
            dataModeOnExistingCollectionsIndicator({
              is_existing_collection_before_data_on:
                (await collectionsApi.getAll()).length > 0,
            }),
          )
          break
        } catch (error) {
          logger.error(
            new Error('Failed to enable data mode', { cause: error }),
          )
          appApi.openErrorPanel()
        }

        break
      }
      case 'developerModeChanged':
        editorSdkProxy.document.application.reloadManifest()
        appApi.refreshSchemasCache()

        appApi.updateAppState({ isDevMode: eventPayload.value })

        if (
          eventPayload.value === true &&
          !isDataModeEnabled(dataSettingsManager)
        ) {
          await enableDataMode({ dataSettingsManager, logger })
        }
        break
      case 'developerModeStatusChanged':
        editorSdkProxy.document.application.reloadManifest()
        break
      default:
        // TODO log something here?
        break
    }
  }
}
